// Pilot 2's other modules, loaded as the Flutter page loads them
// (load_modules.dart), in the same order and 100 ms apart (main.ts).

import type { Bridge } from './bridge';
import type { Config } from './config';

export interface MediaSettings {
  autoUploadPhoto: boolean;
  autoUploadVideo: boolean;
}

/** The api module. Media, ws, mission, tsa and map depend on it; the trailing slash is required. */
export function loadApi(bridge: Bridge, cfg: Config, token: string): void {
  bridge.loadComponent('api', { host: `${cfg.backend}/`, token });
  bridge.apiGetHost();
  bridge.apiGetToken();
}

export function loadLiveshare(bridge: Bridge, cfg: Config, streamId: string, token: string): void {
  bridge.loadComponent('liveshare', { videoPublishType: 'video-demand-aux-manual', statusCallback: '' });
  bridge.liveshareSetConfig(2 /* RTMP */, { url: `${cfg.videoHost}/${streamId}/drone?pass=${token}` });
  bridge.liveshareGetConfig();
  bridge.liveshareSetVideoPublishType('video-demand-aux-manual');
}

export function loadWs(bridge: Bridge, cfg: Config, token: string): void {
  bridge.loadComponent('ws', { host: cfg.wsHost, token, connectCallback: '' });
  bridge.wsConnect(cfg.wsHost, token, '');
}

export function loadMedia(bridge: Bridge, s: MediaSettings): void {
  bridge.loadComponent('media', {
    autoUploadPhoto: s.autoUploadPhoto,
    autoUploadPhotoType: 1,
    autoUploadVideo: s.autoUploadVideo,
  });
  bridge.mediaGetAutoUploadPhoto();
  bridge.mediaGetUploadPhotoType();
  bridge.mediaGetAutoUploadVideo();
}

export function loadMission(bridge: Bridge): void {
  bridge.loadComponent('mission', {});
}

export function loadTsa(bridge: Bridge): void {
  bridge.loadComponent('tsa', {});
}

export function loadMap(bridge: Bridge): void {
  bridge.loadComponent('map', { userName: 'pilot', elementPreName: 'PILOT' });
}
